export enum EPosBrandPayments {
  AMERICAN = 'AMERICAN',
  DINERSCLUB = 'DINERSCLUB',
}



export default EPosBrandPayments;
